const SvgDownloadIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M.538 8.615c.298 0 .539.241.539.539 0 1.03.001 1.75.074 2.291.07.527.2.806.4 1.005.198.199.477.328 1.004.399.542.073 1.26.074 2.291.074h4.308c1.03 0 1.75-.001 2.291-.074.527-.07.806-.2 1.005-.4.199-.198.328-.477.4-1.004.072-.542.073-1.26.073-2.291a.538.538 0 0 1 1.077 0v.04c0 .981 0 1.772-.084 2.395-.087.646-.272 1.19-.705 1.622s-.976.618-1.622.705C10.966 14 10.175 14 9.193 14H4.807c-.982 0-1.774 0-2.396-.084-.646-.087-1.19-.272-1.622-.705S.17 12.235.084 11.59C0 10.966 0 10.175 0 9.193v-.04c0-.297.241-.538.538-.538"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7 10.41a.54.54 0 0 0 .397-.175l2.872-3.14a.539.539 0 0 0-.794-.728L7.539 8.485V.538a.538.538 0 0 0-1.077 0v7.947L4.526 6.367a.538.538 0 0 0-.795.727l2.872 3.141A.54.54 0 0 0 7 10.41"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgDownloadIcon;
